import { StockLocation } from '../types/stock_location';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/stock_location/list';

export namespace StockLocationRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<StockLocation>> => {
    return (await http.post(LIST, payload)).data;
  };
}
